import React from 'react';
import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Map as MapIcon, LocationCity as LocationCityIcon } from '@mui/icons-material';

const DeliveryModulePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ pb: 6 }}>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
          Módulo de entregas
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 520 }}>
          Gerencie cidades, bairros e taxas de entrega do seu delivery. Escolha uma das opções abaixo para
          iniciar o cadastro e configuração.
        </Typography>
      </Box>

      <Stack spacing={3}>
        <Paper variant="outlined" sx={{ p: 3, borderRadius: 3 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 56,
                height: 56,
                borderRadius: '16px',
                bgcolor: 'primary.light',
                color: 'primary.contrastText',
              }}
            >
              <LocationCityIcon />
            </Box>
            <Box flex={1}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Cidades de entrega
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Cadastre e gerencie as cidades atendidas pela sua operação. Necessário antes de cadastrar bairros.
              </Typography>
            </Box>
            <Button variant="contained" onClick={() => navigate('/delivery/cities')}>
              Acessar cidades
            </Button>
          </Stack>
        </Paper>

        <Paper variant="outlined" sx={{ p: 3, borderRadius: 3 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'flex-start', sm: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 56,
                height: 56,
                borderRadius: '16px',
                bgcolor: 'secondary.light',
                color: 'secondary.contrastText',
              }}
            >
              <MapIcon />
            </Box>
            <Box flex={1}>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Bairros e taxas
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Defina os bairros atendidos em cada cidade e as respectivas taxas de entrega por CNPJ.
              </Typography>
            </Box>
            <Button variant="contained" color="secondary" onClick={() => navigate('/delivery/neighborhoods')}>
              Acessar bairros
            </Button>
          </Stack>
        </Paper>
      </Stack>
    </Container>
  );
};

export default DeliveryModulePage;
